import React from 'react';
import Toast from '../../../Common/Modules/Toast';

const ToastDomicilioExistente = () => {
    return <Toast status="warning" title="El Domicilio ya existe">
        <span>No necesitas crearlo, buscalo en el listado de domicilios y seleccionalo para poder utilizarlo.</span>
    </Toast>
}

export default ToastDomicilioExistente;